import React, { useState } from 'react';
import { isValidEmail } from '@/utils/validation';
import { useTelegram } from '@/hooks';

interface EmailInputProps {
  onSubmit: (email: string) => void;
  isLoading?: boolean;
  error?: string | null;
  buttonText?: string;
}

export const EmailInput: React.FC<EmailInputProps> = ({
  onSubmit,
  isLoading = false,
  error,
  buttonText = 'Continue',
}) => {
  const [email, setEmail] = useState('');
  const [localError, setLocalError] = useState<string | null>(null);
  const { impactOccurred } = useTelegram();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!email.trim()) {
      setLocalError('Please enter your email');
      return;
    }

    if (!isValidEmail(email)) {
      setLocalError('Please enter a valid email address');
      return;
    }

    setLocalError(null);
    impactOccurred('medium');
    onSubmit(email.trim().toLowerCase());
  };

  const displayError = error || localError;

  return (
    <form onSubmit={handleSubmit} style={{ width: '100%' }}>
      <div style={{ marginBottom: '16px' }}>
        <label
          htmlFor="email"
          style={{
            display: 'block',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: 500,
            color: 'var(--tg-theme-text-color)',
          }}
        >
          Email Address
        </label>
        <input
          id="email"
          type="email"
          inputMode="email"
          autoComplete="email"
          autoCapitalize="none"
          placeholder="your@email.com"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setLocalError(null);
          }}
          disabled={isLoading}
          style={{
            width: '100%',
            padding: '14px 16px',
            fontSize: '16px',
            border: displayError ? '1px solid #ff3b30' : '1px solid var(--tg-theme-hint-color)',
            borderRadius: '12px',
            backgroundColor: 'var(--tg-theme-secondary-bg-color)',
            color: 'var(--tg-theme-text-color)',
            outline: 'none',
            boxSizing: 'border-box',
          }}
        />
        {displayError && (
          <p
            style={{
              color: '#ff3b30',
              fontSize: '13px',
              marginTop: '6px',
              marginBottom: 0,
            }}
          >
            {displayError}
          </p>
        )}
      </div>

      <button
        type="submit"
        disabled={isLoading || !email.trim()}
        style={{
          width: '100%',
          padding: '14px',
          fontSize: '16px',
          fontWeight: 600,
          backgroundColor: isLoading || !email.trim()
            ? 'var(--tg-theme-hint-color)'
            : 'var(--tg-theme-button-color)',
          color: 'var(--tg-theme-button-text-color)',
          border: 'none',
          borderRadius: '12px',
          cursor: isLoading || !email.trim() ? 'not-allowed' : 'pointer',
          opacity: isLoading ? 0.7 : 1,
        }}
      >
        {isLoading ? 'Sending...' : buttonText}
      </button>
    </form>
  );
};
